import React from "react";
import Header from "./Header";
import ConnectionCard from "./ConnectionCard";
import CalculationCard from "./CalculationCard";
import ConversionCard from "./ConversionCard";
import LoggingCard from "./LoggingCard";
import RecentServiceUrlsCard from "./RecentServiceUrlsCard";
import StaticCopyCard from "./StaticCopyCard";
import VersionCard from "./VersionCard";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";

const Taskpane: React.FC = () => {

  return (
    <>
      <ConnectionCard />
      <AuthenticatedTemplate>
        <CalculationCard />
        <ConversionCard />
        <StaticCopyCard />
        <LoggingCard />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <RecentServiceUrlsCard />
      </UnauthenticatedTemplate>
      <VersionCard />
    </>
  );
};

export default Taskpane;